import React, { useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import TitleBox from '../../components/title-box'
import { FormattedMessage } from 'react-intl'

export default props => {
    useStyles(classes)
    const { payMethod, payMethods, onEdit, selectedCard } = props
    const payMethodInfo = payMethods?.find(p => p.id === payMethod)
    const isCreditMethod =  payMethod === '88' || payMethod === '91' || payMethod === '101' || payMethod === '109'

    return <TitleBox title={<FormattedMessage id="payment_method" defaultMessage="Payment Methods" />}>
        <div className={classes.Container}>
            <span className={classes.Label}>
                <span className={classes.Icon}>
                    <img src={payMethodInfo?.icon} />
                </span>
                
                {
                    isCreditMethod && selectedCard ? <span className={classes.CardNumber}>
                        {selectedCard.quickpayRecord?.cardNumber}
                    </span>: <span className={classes.Title}>
                        {payMethodInfo?.name}
                    </span>
                }

            </span>
            <span onClick={onEdit} className={classes.Editor}><FormattedMessage id="edit" defaultMessage="Edit" /></span>
        </div>
    </TitleBox>
}